import { useAuthContext } from '@/context/auth.context'
import { ROLES, type Role } from '@/constants'
import type { User } from '@/models/user.model'

export interface UseAuthReturn {
  user: User | null
  accessToken: string | null
  isAuthenticated: boolean
  isLoading: boolean
  isAdmin: boolean
  login: (username: string, password: string) => Promise<void>
  logout: () => void
  updateUser: (user: User) => void
  hasRole: (role: Role) => boolean
  hasAnyRole: (roles: Role[]) => boolean
}

export function useAuth(): UseAuthReturn {
  const { user, accessToken, isAuthenticated, isLoading, login, logout, updateUser } =
    useAuthContext()

  return {
    user,
    accessToken,
    isAuthenticated,
    isLoading,
    isAdmin: user?.role === ROLES.ADMIN,
    login,
    logout,
    updateUser,
    hasRole: (role) => user?.role === role,
    hasAnyRole: (roles) => user !== null && roles.includes(user.role),
  }
}
